import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  applicationHistoryRoute,
  applicationHistoryKey,
  errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetApplicationHistoryProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  id?: number | null;
};

export const useGetApplicationHistory = ({
  setErrorText = () => { },
  id,
}: useGetApplicationHistoryProps) => {
  const { data: applicationHistory, isLoading: isLoadingHistory } = useQuery({
    queryKey: [applicationHistoryKey, id],
    queryFn: () => {
      const params = new URLSearchParams();

      params.append('application_id', String(id));

      return axiosInstance
        .get(applicationHistoryRoute, { params })
        .then((res) => res.data);
    },
    onSuccess: (data) => {
      if (data.object) {
        setErrorText('');
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
    refetchOnWindowFocus: false,
    enabled: Boolean(id),
  });

  return {
    applicationHistory,
    isLoadingHistory,
  };
};
